import TyContent from './TyContent.vue'
export default TyContent



// WEBPACK FOOTER //
// ./src/components/ty-content/index.js